import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'

/**
 * A call-to-action link. The label is the node's own inline content — typed
 * directly, the way a heading's text is — so it can be selected and it never
 * drifts out of sync with a separate "label" field the way a title attribute
 * could.
 */
export function ButtonView({ node, updateAttributes, editor }: NodeViewProps) {
  const href = (node.attrs['href'] as string | null) ?? ''
  const style = (node.attrs['style'] as string | null) === 'secondary' ? 'secondary' : 'primary'

  return (
    <NodeViewWrapper className={`be-button be-button--${style}`} data-sls="button">
      {/* `NodeViewContent` renders a `div` by default — TypeScript cannot infer
          its generic `as` parameter from JSX, so it stays a div rather than
          fighting the type. `.be-button__label` sets `display: inline-flex`,
          which is what actually decides how it lays out on the page. */}
      <NodeViewContent className="be-button__label" />
      {editor.isEditable && (
        <div className="be-button__fields" contentEditable={false}>
          <input
            className="be-inline-input"
            value={href}
            placeholder="Link, e.g. /getting-started/intro"
            onChange={(e) => updateAttributes({ href: e.target.value || null })}
          />
          <select
            className="be-select"
            value={style}
            onChange={(e) => updateAttributes({ style: e.target.value })}
          >
            <option value="primary">Primary</option>
            <option value="secondary">Secondary</option>
          </select>
        </div>
      )}
      {!href && (
        <p className="be-button__warn" contentEditable={false}>
          No link yet. This button will render disabled.
        </p>
      )}
    </NodeViewWrapper>
  )
}
